import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const ENV_FLAG = import.meta.env.VITE_ENABLE_PUBLIC_ARTICLES === "true";

/**
 * Returns whether public articles are enabled (combining env flag + runtime DB setting).
 * Runtime setting in app_settings.public_articles_enabled overrides; falls back to env flag while loading.
 */
export function usePublicArticlesEnabled() {
  const [enabled, setEnabled] = useState<boolean>(ENV_FLAG);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    const { data } = await supabase
      .from("app_settings" as any)
      .select("value")
      .eq("key", "public_articles_enabled")
      .maybeSingle();
    const v = (data as any)?.value;
    setEnabled(v === true || v === "true" || ENV_FLAG);
    setLoading(false);
  }

  useEffect(() => { refresh(); }, []);

  async function setRemote(next: boolean) {
    const { error } = await supabase
      .from("app_settings" as any)
      .upsert({ key: "public_articles_enabled", value: next as any, updated_at: new Date().toISOString() }, { onConflict: "key" });
    if (error) throw error;
    setEnabled(next || ENV_FLAG);
  }

  return { enabled, loading, setEnabled: setRemote, refresh };
}
